import api from '@/services/api'

export default {
  getCompanyData() {
    return api.get('/companies')
  },

  updateCompanyData(data) {
    return api.put('/companies', data)
  },

  uploadImage(formData) {
    return api.post('/companies/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  getShippingOptions() {
    return api.get('/shipping-options')
  },

  updateShippingOption(data) {
    return api.put('/shipping-options', data);
  }
}